<template>
    <v-img :src=imgSrc.pic
           aspect-ratio="0.76"
           class="grey lighten-2"
           @mouseenter="enter()"
           @mouseleave="leave()"
    >
        <template v-slot:placeholder>
            <v-row
                    class="fill-height ma-0"
                    align="center"
                    justify="center"
            >
                <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
            </v-row>
        </template>
        <div v-if="imgMask" class="nong-publications-img-mask">
            <span class="nong-works-img-title">{{locale=='cn'?imgSrc.name:imgSrc.enName}}</span>
            <span>{{imgSrc.particularYear}}</span>
        </div>
    </v-img>
</template>

<script>
export default {
  name: "publicationList",
  props: ['imgSrc'],
  data(){
    return{
      imgMask:false,
      locale:'cn'
    }
  },
  created(){
    if (localStorage.getItem('locale') == 'zh-CN') {
      this.locale='cn'
    }else {
      this.locale='en'
    }
  },
  methods: {
    enter() {
      this.imgMask = true
    },
    leave() {
      this.imgMask = false
    }
  }
}
</script>

<style scoped>
    .nong-publications-img-mask{
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        color: white;
        font-size: 9px;
        line-height: 18px;
        background : rgba(0, 0, 0, 0.5)
    }

    .nong-works-img-title {
        font-size: 13px;
        text-align: center;
    }
</style>
